// controllers
import ModalController from '../../../assets/js/controllers/modal';

// constants
import WistiaEvent from '../../../assets/js/constants/wistia-event';

// helpers
import { classesActiveAndIn } from '../../../assets/js/helpers';

export default class SubmoduleHeroWebinar {

	static selector = 'submodule-hero-webinar';

	// class variables

	el = {};

	states = {
		activeDescription: null,
		total: 0,
		wistiaApiRef: null
	};

	// constructor

	constructor(container) {
		this.el = {
			container,
			ctaPlay: container.querySelector(`.${this.constructor.selector}__video-cta-play`),
			wistiaVideo: container.querySelector(`.${this.constructor.selector}__video-wistia`)
		};

		this.initialize();
	}

	// initialize

	initialize() {
		this.#addEventListeners();
	}

	// add and remove listeners

	#addEventListeners = () => {
		this.el.ctaPlay.addEventListener('click', this.#onVideoPlayClick);
		document.body.addEventListener(WistiaEvent.GATE_UNLOCKED, this.#onGateUnlocked);
	}

	#removeEventListeners = () => {
		this.el.ctaPlay.removeEventListener('click', this.#onVideoPlayClick);
		document.body.removeEventListener(WistiaEvent.GATE_UNLOCKED, this.#onGateUnlocked);
	}

	// listener methods

	#onVideoPlayClick = (e) => {
		ModalController.open(this.el.ctaPlay.getAttribute('data-modal-id'));
	}

	#onGateUnlocked = (e) => {
		const { wistiaId } = e.detail;
		classesActiveAndIn(this.el.wistiaVideo);

		this.states.wistiaApiRef = Wistia.api(wistiaId);
		this.states.wistiaApiRef.play();
	}

	// destroy

	destroy() {
		this.#removeEventListeners();
	}

}
